export const libraryRoutes = {
  // Global snippets
  snippets: '/library/snippets',
  snippetNames: '/library/snippets/names',
  snippet: (token: string) => `/library/snippets/${token}`,
  snippetMetadata: (token: string) => `/library/snippets/${token}/metadata`,
  snippetVersion: (token: string, version: number) => `/library/snippets/${token}/versions/${version}`,
  snippetVersions: (token: string) => `/library/snippets/${token}/versions`,
  publishSnippet: (token: string) => `/library/snippets/${token}/publish`,
  unpublishSnippet: (token: string) => `/library/snippets/${token}/unpublish`,
  archiveSnippet: (token: string) => `/library/snippets/${token}/archive`,
  unarchiveSnippet: (token: string) => `/library/snippets/${token}/unarchive`,
  filters: '/library/filters',
  // Dashboard routes - Global Repository
  globalRepository: {
    view: '/v3/dashboard/admin/library/global-repository/',
    details: (snippetToken: string) => `/v3/dashboard/admin/library/global-repository/${snippetToken}/`,
    versionCreate: (snippetToken: string) => `/v3/dashboard/admin/library/global-repository/${snippetToken}/versions/create`,
    versionUpdate: (snippetToken: string, versionNumber: number) => `/v3/dashboard/admin/library/global-repository/${snippetToken}/versions/${versionNumber}/update`,
  },

  // Local snippets
  localSnippets: '/library/local/snippets',
  localSnippetWorkflowNames: '/library/local/snippets/workflow-names',
  localSnippet: (token: string) => `/library/local/snippets/${token}`,
  localSnippetMetadata: (token: string) => `/library/local/snippets/${token}/metadata`,
  localSnippetVersions: (token: string) => `/library/local/snippets/${token}/versions`,
  archiveLocalSnippet: (token: string) => `/library/local/snippets/${token}/archive`,
  unarchiveLocalSnippet: (token: string) => `/library/local/snippets/${token}/unarchive`,
  publishLocalSnippet: (token: string) => `/library/local/snippets/${token}/publish`,
  unpublishLocalSnippet: (token: string) => `/library/local/snippets/${token}/unpublish`,

  // Dashboard routes - Local Snippets
  localSnippetsList: '/v3/dashboard/workflows?tab=snippets',
  localSnippetsView: '/v3/dashboard/snippets/',
  localSnippetDetails: (snippetToken: string) => `/v3/dashboard/snippets/${snippetToken}/`,
  localSnippetVersionCreate: (snippetToken: string) => `/v3/dashboard/snippets/${snippetToken}/versions/create`,
  localSnippetVersionUpdate: (snippetToken: string, versionNumber: number) => `/v3/dashboard/snippets/${snippetToken}/versions/${versionNumber}/update`,
} as const;
